// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faTwitter,
  faFacebook,
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons"

// Importing icons into this file and adding them to the library below
// will allow you to access the icons by their friendly name.
//
// See the gallery for what's available:
// https://fontawesome.com/icons
library.add(faTwitter, faFacebook, faGithub, faLinkedin)
